import { Box, Typography, Chip, Link } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import VideocamIcon from '@mui/icons-material/Videocam';
import React, { useEffect, useState } from 'react';
import globals from "../globals";
import { useAuth } from '../context/AuthContext';

const StudentList = ({ students }) => {
    if (!students || students.length === 0) {
        return <Typography sx={{ fontSize: 13, color: globals.colors.gray }}>—</Typography>;
    }
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            {students.map((student, index) => (
                <Box key={`${student.child_name}-${index}`}>
                    <Typography sx={{ fontSize: 13, fontWeight: 'bold' }}>{student.child_name}</Typography>
                    {student.parent_email && (
                        <Typography sx={{ fontSize: 11, color: globals.colors.gray }}>
                            {student.parent_name ? `${student.parent_name} · ` : ''}{student.parent_email}
                        </Typography>
                    )}
                </Box>
            ))}
        </Box>
    );
};

const SummerSchoolRegistrations = () => {
    const { token } = useAuth();
    const [grades, setGrades] = useState([]);
    const [weeks, setWeeks] = useState([]);

    useEffect(() => {
        fetch(`${globals.apiUrl}/summer-school/registrations`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(response => response.json())
            .then(data => {
                setGrades(data.grades || []);
                setWeeks(data.weeks || []);
            })
            .catch(error => {
                console.error('Failed to fetch summer school registrations', error);
            });
    }, [token]);

    const totalStudents = weeks.reduce((sum, week) => sum + week.total, 0);

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography sx={{ fontSize: 22, fontWeight: 'bold', color: globals.colors.darkBlue }}>
                    Записани ученици за лятната занималня
                </Typography>
                <Chip
                    label={`Общо: ${totalStudents}`}
                    sx={{ fontWeight: 'bold', backgroundColor: globals.colors.darkBlue, color: 'white' }}
                />
            </Box>

            <TableContainer component={Paper}>
                <Table size="small" aria-label="summer school registrations table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold' }}>Седмица</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }} align="center">Zoom</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }} align="center">Общо ученици</TableCell>
                            {grades.map((grade) => (
                                <TableCell key={`head-${grade}`} sx={{ fontWeight: 'bold' }} align="center">
                                    {grade}. клас
                                </TableCell>
                            ))}
                            {grades.map((grade) => (
                                <TableCell key={`head-list-${grade}`} sx={{ fontWeight: 'bold' }}>
                                    Ученици в {grade}. клас
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {weeks.map((week) => (
                            <TableRow key={week.week} sx={{ verticalAlign: 'top' }}>
                                <TableCell component="th" scope="row" sx={{ fontWeight: 'bold', color: globals.colors.lightRed }}>
                                    {week.label}
                                </TableCell>
                                <TableCell align="center">
                                    {week.zoom_start_url ? (
                                        <Link
                                            href={week.zoom_start_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: 0.5,
                                                color: globals.colors.darkBlue,
                                                fontWeight: 'bold',
                                                textDecoration: 'none',
                                            }}
                                        >
                                            <VideocamIcon fontSize="small" /> Старт
                                        </Link>
                                    ) : '—'}
                                </TableCell>
                                <TableCell align="center" sx={{ fontSize: 18, fontWeight: 'bold' }}>
                                    {week.total}
                                </TableCell>
                                {grades.map((grade) => (
                                    <TableCell key={`${week.week}-count-${grade}`} align="center" sx={{ fontWeight: 'bold' }}>
                                        {week.grades[grade] ? week.grades[grade].count : 0}
                                    </TableCell>
                                ))}
                                {grades.map((grade) => (
                                    <TableCell key={`${week.week}-list-${grade}`}>
                                        <StudentList students={week.grades[grade] ? week.grades[grade].students : []} />
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Typography sx={{ fontSize: 12, color: globals.colors.gray, mt: 2 }}>
                Всяка седмица има собствена Zoom среща, която се повтаря всеки ден от седмицата. Бутонът „Старт“ отваря срещата като домакин.
            </Typography>
        </Box>
    );
};

export default SummerSchoolRegistrations;
